import React, { useState, useCallback, useEffect } from "react";
import GoogleMapReact, { Props } from "google-map-react";
import Marker from "./Marker";

interface MapDraggableMarkerProps
    extends Omit<
        Props,
        | "bootstrapURLKeys"
        | "defaultCenter"
        | "yesIWantToUseGoogleMapApiInternals"
        | "defaultZoom"
        | "draggable"
        | "onChildMouseMove"
        | "onChildMouseUp"
    > {
    latitude?: number;
    longitude?: number;
    accurateAddress?: boolean;
    googleApiToken: string;
    onChangeCoordinates?: (lat: number, long: number) => void;
    mapHeight?: string;
    mapWidth?: string;
}

const MapDraggableMarker: React.FC<MapDraggableMarkerProps> = ({
    latitude,
    longitude,
    accurateAddress = true,
    googleApiToken,
    onChangeCoordinates,
    mapHeight = "100vh",
    mapWidth = "100%",
    ...rest
}) => {
    const [isDragginMark, setIsDraggingMark] = useState(false);
    const [mapCenter, setMapCenter] = useState({
        lat: latitude,
        lng: longitude,
    });
    const [draggable, setDraggable] = useState(true);

    const onChangeMarker = useCallback(
        (childKey, childProps, mouse) => {
            setDraggable(false);
            setIsDraggingMark(true);
            onChangeCoordinates(mouse.lat, mouse.lng);
        },
        [setDraggable]
    );
    const onStopChangeMarker = useCallback(
        (childKey, childProps, mouse) => {
            setDraggable(true);
            setIsDraggingMark(false);
            setMapCenter({ lat: mouse.lat, lng: mouse.lng });
        },
        [setDraggable]
    );

    const onChange = useCallback(
        ({ center }) => {
            console.log(center);

            setMapCenter(center);
        },
        [setMapCenter]
    );

    useEffect(() => {
        // para não prejudicar a experiência do usuário, enquanto estiver arrastando não mudar o centro
        !isDragginMark && setMapCenter({ lat: latitude, lng: longitude });
    }, [latitude, longitude]);

    return (
        <div style={{ height: mapHeight, width: mapWidth }}>
            <GoogleMapReact
                bootstrapURLKeys={{ key: googleApiToken }}
                center={mapCenter}
                yesIWantToUseGoogleMapApiInternals
                defaultZoom={accurateAddress == true ? 15 : 11}
                onChildMouseMove={onChangeMarker}
                onChildMouseUp={onStopChangeMarker}
                onChange={onChange}
                draggable={draggable}
                {...rest}
            >
                {accurateAddress == true && (
                    <Marker lat={latitude} lng={longitude} />
                )}
            </GoogleMapReact>
        </div>
    );
};

export { MapDraggableMarker, MapDraggableMarkerProps };
